import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  Image,
  VStack,
  // HStack,
  // Spacer,
  // Divider,
  useBreakpointValue,
} from '@chakra-ui/react';

import { getImageUrl } from 'utils/ImageImporter';

// const data = {
//   storyTitle: 'when I enter the restaurant',
//   starter: 'When I enter the restaurant ...',
//   round: 0,
//   status: 'To Do',
//   instruction:
//     'Your character walks into their favorite restaurant, but the chef had prepared something utterly disgusting instead of the normal menu. Right on their plate was…',
//   // url: 'https://images.cartoonstock.com/lowres_800/money-banking-expensive_restaurant-posh_restaurant-restaurant_bill-restaurant_check-restaurant_cheque-amrn1157_low.jpg',
//   genre: 'fantasy',
//   skipAllowed: false,
//   maxRound: null,
//   maxWordCount: 2000,
//   minSegmentWordCount: 50,
//   maxSegmentWordCount: 150,
// };

const RelayPrompt = ({
  storyTitle,
  starter,
  instruction,
  extraInstruction,
  status,
  round,
  url,
  genre,
  skipAllowed,
  maxWordCount,
  minSegmentWordCount,
  maxSegmentWordCount,
  startRelay,
  isSubmitting,
}) => {
  const [showPrompt, setShowPrompt] = useState(true);

  const togglePrompt = () => setShowPrompt((prev) => !prev);

  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box width={'100%'}>
      <Flex justify="flex-end" mb={2}>
        <Text
          color="blue.500"
          cursor="pointer"
          textDecoration="underline"
          onClick={togglePrompt}
          // marginRight={labelShift ? 2 : 0}
        >
          {showPrompt ? 'Hide Rules' : 'Show Rules'}
        </Text>
      </Flex>

      {showPrompt && (
        <Box
          p={5}
          borderWidth="1px"
          borderRadius="lg"
          boxShadow="md"
          bg="green.50"
          mb={6}
        >
          <Flex direction={isMobile ? 'column' : 'row'} gap={4}>
            {/* Text and Buttons Section */}
            <Box mb={2} flex={isMobile ? '1' : '0.7'}>
              <Heading size="md" color="teal.700">
                Impropmtu Story Rules
              </Heading>
              {/* Story Title */}
              {storyTitle && (
                <Box ml={2} mt={2}>
                  <Text fontWeight="bold" color="gray.600">
                    Title:
                  </Text>
                  <Text>{storyTitle}</Text>
                </Box>
              )}

              {/* Instruction */}
              {/* {instruction && <Text mb={4}>{instruction}</Text>} */}
              <Box ml={2} mt={2}>
                <Text fontWeight="bold" color="gray.600">
                  Instruction:
                </Text>
                {starter && (
                  <Text textAlign="justify">
                    Write a story starts with &quot;<strong>{starter}</strong>
                    &quot;
                  </Text>
                )}
                <Text textAlign="justify">{instruction}</Text>
                <Text textAlign="justify">{extraInstruction}</Text>
              </Box>
              <Flex ml={2} mt={2}>
                <Box flex="1">
                  <Text color="gray.600" mb={2}>
                    <strong>Chance to Skip:</strong> {`${skipAllowed}`}
                  </Text>
                </Box>
                <Box flex="1">
                  {/* {maxRound && (
                    <Text color="gray.600">
                      <strong>Max Round:</strong> {maxRound}
                    </Text>
                  )} */}
                  {maxWordCount && (
                    <Text color="gray.600">
                      <strong>Max Story Words:</strong> {maxWordCount}
                    </Text>
                  )}
                </Box>
              </Flex>
              <Flex ml={2}>
                <Box flex="1">
                  <Text color="gray.600" mb={2}>
                    <strong>Min Words / Round:</strong> {minSegmentWordCount}
                  </Text>
                </Box>
                <Box flex="1">
                  <Text color="gray.600" mb={2}>
                    <strong>Max Words / Round:</strong> {maxSegmentWordCount}
                  </Text>
                </Box>
              </Flex>

              {/* Status and Buttons */}
              {status === 'To Do' || round === 0 ? (
                <VStack align="start" spacing={3} mt={4}>
                  <Text>
                    Click the buttons below to begin the game. Choose whether to
                    take the lead or follow along!
                  </Text>
                  <Flex gap={3}>
                    <Button
                      colorScheme="teal"
                      onClick={() => startRelay(true)}
                      isLoading={isSubmitting}
                      isDisabled={isSubmitting}
                    >
                      Lead the Way
                    </Button>
                    <Button
                      colorScheme="green"
                      onClick={() => startRelay(false)}
                      isLoading={isSubmitting}
                      isDisabled={isSubmitting}
                    >
                      Follow Along
                    </Button>
                  </Flex>
                </VStack>
              ) : null}
            </Box>

            {/* Thumbnail Section */}
            {!isMobile && (
              <Box flex="0.3" textAlign="center">
                <Image
                  src={getImageUrl(url || genre)}
                  alt={`${genre} Story Thumbnail`}
                  borderRadius="md"
                  boxSize="100%"
                  objectFit="cover"
                />
              </Box>
            )}
          </Flex>
        </Box>
      )}
    </Box>
  );
};

RelayPrompt.propTypes = {
  // promptData: PropTypes.objectOf(
  //   PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  // ),
  storyTitle: PropTypes.string,
  starter: PropTypes.string,
  instruction: PropTypes.string,
  extraInstruction: PropTypes.string,
  status: PropTypes.string,
  round: PropTypes.number,
  url: PropTypes.string,
  genre: PropTypes.string,
  skipAllowed: PropTypes.bool,
  maxWordCount: PropTypes.number,
  minSegmentWordCount: PropTypes.number,
  maxSegmentWordCount: PropTypes.number,
  defaultShow: PropTypes.bool,
  labelShift: PropTypes.bool,
  startRelay: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

export default RelayPrompt;
